
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/poweron-pipelines",
      function () {
        return require("private-next-pages/legal/poweron-pipelines/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/poweron-pipelines"])
      });
    }
  